import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import { testingUsersAccess } from './Constants/Functions';
import UnderConstructionApp from './Sandbox/UnderConstructionApp';

import Home from './Pages/Home';
import NewsRoom from './Pages/NewsRoom';
import Roadmap from './Pages/Roadmap';
import TheWall from './Pages/TheWall';
import EditArticles from './Pages/EditArticles';

function AppRoutes(props) {

    // console.log(props.provider.authenticationState)
    var authenticationState = props.provider.authenticationState;
    var userEmail = props.provider.account.userName;

    return (
        <div>
            {authenticationState === "Authenticated" ?
                (
                    <Router>
                        <Switch>
                            {/* <Route path="/" render={(rest) => <Home {...props} {...rest} />} exact={true} /> */}
                            {/* <Route path="/NewsRoom" render={(rest) => <NewsRoom {...props}  {...rest} />} /> */}
                            <Route path="/" render={(rest) => <TheWall {...props} {...rest} />} exact={true} />
                            {/* <Route path="/Roadmap" render={(rest) => <Roadmap {...props}  {...rest} exact={true} />} />
            <Route path="/EditArticles" render={(rest) => <EditArticles {...props}  {...rest} exact={true} />} /> */}
                            {/* <Route path="/TheWall" render={(rest) => <TheWall {...props}  {...rest} />} /> */}
                        </Switch>
                    </Router>
                ) : null
                // (
                //     process.env.NODE_ENV === "development"  || testingUsersAccess(userEmail)?
                //         (
                //             <Router>
                //                 <Switch>
                //                     {/* <Route path="/" render={(rest) => <Home {...props} {...rest} />} exact={true} /> */}
                //                     {/* <Route path="/NewsRoom" render={(rest) => <NewsRoom {...props}  {...rest} />} /> */}
                //                     <Route path="/" render={(rest) => <TheWall {...props} {...rest} />} exact={true} />
                //                     {/* <Route path="/Roadmap" render={(rest) => <Roadmap {...props}  {...rest} exact={true} />} />
                //                     <Route path="/EditArticles" render={(rest) => <EditArticles {...props}  {...rest} exact={true} />} /> */}
                //                     {/* <Route path="/TheWall" render={(rest) => <TheWall {...props}  {...rest} />} /> */}
                //                 </Switch>
                //             </Router>
                //         ) : <UnderConstructionApp />
                // ) : null
            }
        </div>

    )
}

export default AppRoutes;